module.exports = "/_next/static/images/customer-review-sarah1-min-181080aae149b923db8f0464dde3b68f.png";